var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRarely(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    className: "icon medium",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 2C8.30547 2 2 8.30547 2 16C2 23.6945 8.30547 30 16 30C23.6945 30 30 23.6945 30 16C30 8.30547 23.6945 2 16 2ZM5.33594 16C5.33594 10.1265 10.1265 5.33594 16 5.33594C18.2148 5.33594 20.3477 6.02495 22.1687 7.32104L16 13.4898L7.32115 22.1687C6.02495 20.3476 5.33594 18.2148 5.33594 16ZM16 26.6641C13.7852 26.6641 11.6523 25.9749 9.83125 24.6789L24.6789 9.8312C25.9751 11.6523 26.6641 13.7851 26.6641 16C26.6641 21.8734 21.8735 26.6641 16 26.6641Z",
    fill: "#64AB88"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30 16C30 23.6945 23.6945 30 16 30V26.6641C21.8735 26.6641 26.6641 21.8734 26.6641 16C26.6641 13.7851 25.9751 11.6523 24.6789 9.83125L16 18.5101V13.4898L22.1687 7.32104C20.3477 6.02495 18.2148 5.33594 16 5.33594V2C23.6945 2 30 8.30547 30 16Z",
    fill: "#429E71"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRarely);
export default __webpack_public_path__ + "static/media/rarely.2ed808473f6e81ffebc6fd4744b1e312.svg";
export { ForwardRef as ReactComponent };